import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ParseJson } from 'ZalamoLibrary/src/lib/core/decorators/ParseJson';
import { UserWallEvent } from '../../../../../../../../graphql/libs/viewer-wall/types';
import { UserWallEventType } from '../../graphql';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { pluck } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { navigationSetIsOpen } from 'ZalamoLibrary/src/lib/ui/navigation/navigation-state/navigation-state.actions';

@Component({
    selector: 'app-zalamo-welcome-message',
    templateUrl: './zalamo-welcome-message.component.html',
    styleUrls: ['./zalamo-welcome-message.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ZalamoWelcomeMessageComponent implements OnInit {
  @Input()
  @ParseJson
  details: UserWallEvent[UserWallEventType.ZalamoWelcomeMessage];

  isMobile$ = this.breakpointObserver
    .observe(Breakpoints.Handset)
    .pipe(pluck('matches'));
  mouseOverAddIcon = false;

  constructor(
    private breakpointObserver: BreakpointObserver,
    private store: Store
  ) {}

  ngOnInit(): void {}

  hideHover() {
    if (document.getElementById('ZalamoHelperOverlay')) {
      document
        .querySelectorAll('#ZalamoHelperOverlay')
        .forEach((el) => document.body.removeChild(el));

      this.store.dispatch(navigationSetIsOpen({ isOpen: false }));
    }

    this.mouseOverAddIcon = false;
  }

  openHover(element: HTMLElement) {
    const { width, height, x, y } = element.getBoundingClientRect();
    const path = this.makeOverlayPath(element.getBoundingClientRect());

    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.id = 'ZalamoHelperOverlay';
    svg.style.width = '100%';
    svg.style.height = '100%';
    svg.style.position = 'fixed';
    svg.style.top = '0';
    svg.style.left = '0';
    svg.style.zIndex = '999999999';
    svg.style.opacity = '0';
    svg.style.pointerEvents = 'none';

    svg.innerHTML = `<path d="${path}" />`;
    document.body.appendChild(svg);
    svg.animate(
      [
        // keyframes
        { opacity: 0 },
        { opacity: '.4' },
      ],
      {
        // timing options
        duration: 500,
        fill: 'forwards',
      }
    );
  }

  showAddHover() {
    this.mouseOverAddIcon = true;
    this.store.dispatch(navigationSetIsOpen({ isOpen: true }));
    setTimeout(() => {
      this.openHover(document.getElementById('ZalamoMainMenuAddButton'));
      if (!this.mouseOverAddIcon) {
        setTimeout(() => this.hideHover(), 1000);
      }
    }, 150);
  }

  showOrdersHover() {
    this.mouseOverAddIcon = true;

    this.store.dispatch(navigationSetIsOpen({ isOpen: true }));
    setTimeout(() => {
      this.openHover(document.getElementById('ZalamoMainMenuorder_list'));
      if (!this.mouseOverAddIcon) {
        setTimeout(() => this.hideHover(), 1000);
      }
    }, 150);
  }

  makeOverlayPath({ width, height, x = 0, y = 0, r = 0 }) {
    const { innerWidth: w, innerHeight: h } = window;

    return `M${w},${h}\
H0\
V0\
H${w}\
V${h}\
Z\
M${x + r},${y}\
a${r},${r},0,0,0-${r},${r}\
V${height + y - r}\
a${r},${r},0,0,0,${r},${r}\
H${width + x - r}\
a${r},${r},0,0,0,${r}-${r}\
V${y + r}\
a${r},${r},0,0,0-${r}-${r}\
Z`;
  }
}
